import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../../component/BreadCrumbBanner";
import facilitiesAPI from "../../api/facilitiesApi";

const TuckShop = () => {
  const [tuckShop, setTuckShop] = useState(null);

  useEffect(() => {
    fetchTuckShop();
  }, []);

  const fetchTuckShop = async () => {
    const res = await facilitiesAPI.tuck_shop();

    if (res.code === 200) {
      const result = res.data;
      setTuckShop(result);
    }
  };
  const tuckShopData = tuckShop?.["tuck-shop"]?.[0];
  return (
    <>
      {/* BreadCrump Section */}
      <BreadCrumbBanner
        title="Tuck shop / Canteen"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {tuckShopData && (
        <>
          {/* Safe & Clean Environment */}
          <section className="canteen-cleanliness-section pt-5 bg-light">
            <div className="container">
              <div className="row justify-content-center text-center">
                <div className="col-lg-12">
                  <h2 className="mrv-title">{tuckShopData?.title}</h2>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: tuckShopData?.shortdescription || "",
                    }}
                  />
                </div>
              </div>
            </div>
          </section>

          {/* canteen section */}
          <section className="canteen-clean-section bg-light">
            <div className="container">
              <div className="row align-items-center g-5">
                {/* LEFT CONTENT */}
                <div className="col-lg-6 animate__animated animate__fadeInLeft order-lg-1 order-2">
                  <span className="mrv-subtitle">{tuckShopData?.subtitle}</span>
                  <h2 className="mrv-title">
                   {tuckShopData?.name}
                  </h2>
                  <p className="canteen-desc">
                    <div
                    dangerouslySetInnerHTML={{
                      __html: tuckShopData?.description || "",
                    }}
                  />
                  </p>
                 
                </div>
                {/* RIGHT IMAGE */}
                <div className="col-lg-6 animate__animated animate__fadeInRight order-lg-2 order-1">
                  <div className="canteen-image-box">
                    <img
                      src={tuckShopData?.image}
                      alt="School Canteen"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default TuckShop;
